export const Users = [
    {
      id:1,
      profilePicture: "./person/1.jpg",
      username: "user",
    },
    {
      id:2,
      profilePicture: "./person/2.jpg",
      username: "user",
    },
    {
      id:3,
      profilePicture: "./person/3.jpg",
      username: "user",
    },
    {
      id:4,
      profilePicture: "./person/4.jpg",
      username: "user",
    },
    {
      id:5,
      profilePicture: "./person/5.jpg",
      username: "user",
    },
    {
      id:6,
      profilePicture: "./person/6.jpg",
      username: "user",
    },
    {
      id:7,
      profilePicture: "./person/7.jpg",
      username: "user",
    },
    {
      id:8,
      profilePicture: "./person/8.jpg",
      username: "user",
    },
    {
      id:9,
      profilePicture: "./person/9.jpg",
      username: "user",
    },

  ];
  
  // export const Posts = [
  //   {
  //     id: 1,
  //     desc: "Love For All, Hatred For None.",
  //     photo: "post/1.jpg",
  //     date: "5 mins ago",
  //     userId: 1,
  //     like: 32,
  //     comment: 9,
  //   },
  //   {
  //     id: 2,
  //     photo: "post/2.jpg",
  //     date: "15 mins ago",
  //     userId: 2,
  //     like: 2,
  //     comment: 1,
  //   },
  //   {
  //     id: 3,
  //     desc: "Every moment is a fresh beginning.",
  //     photo: "post/3.jpg",
  //     date: "1 hour ago",
  //     userId: 3,
  //     like: 61,
  //     comment: 2,
  //   },
  //   {
  //     id: 4,
  //     photo: "post/4.jpg",
  //     date: "4 hours ago",
  //     userId: 4,
  //     like: 7,
  //     comment: 3,
  //   },
  //   {
  //     id: 5,
  //     photo: "post/5.jpg",
  //     date: "5 hours ago",
  //     userId: 5,
  //     like: 23,
  //     comment: 5,
  //   },
  //   {
  //     id: 6,
  //     photo: "post/6.jpg",
  //     date: "1 day ago",
  //     userId: 6,
  //     like: 44,
  //     comment: 6,
  //   },
  //   {
  //     id: 7,
  //     desc: "Never regret anything that made you smile.",
  //     photo: "post/7.jpg",
  //     date: "2 days ago",
  //     userId: 7,
  //     like: 52,
  //     comment: 3,
  //   },
  //   {
  //     id: 8,
  //     photo: "post/8.jpg",
  //     date: "3 days ago",
  //     userId: 8,
  //     like: 15,
  //     comment: 1,
  //   },
  //   {
  //     id: 9,
  //     desc: "Change the world by being yourself.",
  //     photo: "post/9.jpg",
  //     date: "5 days ago",
  //     userId: 9,
  //     like: 11,
  //     comment: 2,
  //   },
  // ];